import { AttendanceActivityLogs } from '@/components/attendance/AttendanceActivityLogs';

export default function AttendanceActivityPage() {
  return (
    <div className="container mx-auto p-6 space-y-6">
      <div>
        <h1 className="text-3xl font-bold">Attendance Activity</h1>
        <p className="text-muted-foreground mt-2">
          Monitor attendance discrepancies and manage attendance flags
        </p>
      </div>
      <AttendanceActivityLogs />
    </div>
  );
}